// A program is only shown publicly when it is active. Drafts (next-term copies
// being prepared) and paused programs stay hidden without losing any data.
const HIDDEN_STATUSES = ['draft', 'paused', 'archived'];

export const isProgramPublic = (program) =>
  !HIDDEN_STATUSES.includes(program?.status || 'active');
